import en from './en';
import it from './it';
import da from './da';

const lan = {en, it, da};
const lang_code = process.env.ENV !== 'test'
    ? window.navigator.language.split('-')[0]
    : 'en';

// Language code detected from the browser locale (e.g. 'it', 'en', 'da').
// Reused outside i18n (e.g. to pick the localized privacy-policy URL).
export const LANGUAGE_CODE = lang_code;

export const DEFAULT_LANGUAGE = en;

export default lan[lang_code] || DEFAULT_LANGUAGE;